export default __webpack_public_path__ + "static/media/moonspill.418474c7.jpg";